import { gql } from 'graphql-request'

export const GET_LIVE_CHECKIN_TASKS_DEFAULTS = gql`
  query GET_LIVE_CHECKIN_TASKS_DEFAULTS(
    $take: Int
    $skip: Int
    $active: Boolean
    $deleted: Boolean
  ) {
    getLiveCheckinTasksDefaults(
      take: $take
      skip: $skip
      active: $active
      deleted: $deleted
    ) {
      status
      error
      totalPages
      data {
        id
        liveCheckinLevelId
        liveCheckinTaskType
        nameKey
        internalName
        descriptionKey
        internalDescription
        emoji
        targetValue
        pointReward
        sortOrder
        active
        deleted
      }
    }
  }
`
